import { defineStore } from 'pinia'

import type { Validation } from '@/types/validation'

interface UploadedCreativeState {
  uploadedCreativeUrl: string
  validations: Validation[]
}

export const useUploadedCreativeStore = defineStore('UploadedCreative', {
  state: (): UploadedCreativeState => ({
    uploadedCreativeUrl: '',
    validations: [],
  }),
  actions: {
    setUploadedCreativeUrl(url: string) {
      this.uploadedCreativeUrl = url
    },
    setValidations(validation: Validation[]) {
      this.validations = validation
    },
    resetUploadedCreativeState() {
      this.uploadedCreativeUrl = ''
      this.validations = []
    },
  },
})
